import React from "react";
import { IonButton, IonImg } from "@ionic/react";
import "../../global.scss";

interface ButtonFields {
  label: string;
  hasImg: Boolean;
  className: string;
  onClick: Function;
  disabled?: boolean;
}

export const CutsomButtom: React.FC<ButtonFields> = ({
  label,
  hasImg,
  className,
  onClick,
  disabled = false,
}: ButtonFields) => {
  return (
    <IonButton color="primary" className={className} disabled={disabled} expand="block" onClick={() => onClick()}>
      {hasImg && <IonImg src="/images/Vector.svg" className="call-icon" />}
      {label}
    </IonButton>
  );
};

export const CustomButtonMobile: React.FC<ButtonFields> = ({
  label,
  hasImg,
  onClick,
  disabled = false,
}: ButtonFields) => {
  return (
    <IonButton className="login-mobile" disabled={disabled} expand="block" color="primary" onClick={() => onClick()}>
      {hasImg && <img src="/images/Vector.svg" className="call-icon" />}
      {label}
    </IonButton>
  );
};
